import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-pcomp-jquitabs',
	templateUrl:'./JQUITabsPluginCompPage.html',
	styles: [],
	styleUrls:['./JQUITabsPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class JQUITabsPluginCompPage
{
	mdContent_1027 = `\`\`\`java
import com.jwebmp.plugins.jqueryui.tabs.JQUITabs;
\`\`\``;
	mdContent_1028 = `\`\`\`java
JQUITabs()
\`\`\``;
	mdContent_1029 = `\`\`\`java
JQUITabs&lt;?&gt; tabs = new JQUITabs&lt;&gt;();
tabs.addTab("Tab 1", new DivSimple&lt;&gt;().setText("Content 1"));
tabs.addTab("Tab 2", new DivSimple&lt;&gt;().setText("Content 2"));
tabs.getOptions().setCollapsible(true);
\`\`\``;
}
